import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IAnswer } from '../model/answer.interface';

export interface JoinCommunityDTO {
  email: string;
  agree_to_privacy: boolean;
}

@Injectable()
export class JoinToCommunityService {
  private root: string = environment.URL;

  constructor(private http: HttpClient) {}

  public subscribe(dto: JoinCommunityDTO): Observable<IAnswer<void>> {
    return this.http.post<IAnswer<void>>(`${this.root}/funnel/welcome`, dto);
  }
}
